/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateProxySubmissionDataParser = 
/* #__PURE__ */ parsers.object([
    ['allowRemoteResources', codecBoolean, 'allow_remote_resources'],
    ['allowRemoteScripts', codecBoolean, 'allow_remote_scripts'],
    ['teacherRevision', codecBoolean, 'teacher_revision'],
]);
export class CreateProxySubmissionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateProxySubmissionDataParser.decode(input).map(res => new CreateProxySubmissionData(res));
    }
    static unsafeDecode(input) {
        return CreateProxySubmissionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateProxySubmissionDataParser.encode(data);
    }
    static schema() {
        return CreateProxySubmissionDataParser.schema();
    }
}
